import { GlobalNotificationHandlerDefinition } from './global-handler';
import { WebSocketEventEntityType, WebSocketEventOperation } from '../ws-event.service';

export const notificationAllHandler: GlobalNotificationHandlerDefinition<any> = {
    entity: WebSocketEventEntityType.all,
    operation: WebSocketEventOperation.all,
    isCustomNotification: false,
    notificationBuilder: event => {
        const { operation, ['display-data']: displayData, ['entity-type']: entityType, user, company, reference } = event;
        return {
            id: event.id,
            title: displayData?.title || `${entityType} ${operation}`,
            content: displayData?.message || `${entityType} ${reference} has been ${operation} by ${user} (at company ${company})`,
            context: 'info'
        };
    }
};
